<div class="hours" data-testid="hours">
    <!-- Bulk Edit Header -->
    <div class="hours__header" data-testid="hours-header">
        <ntv-button variant="primary" size="xl" rounded="md" (buttonClick)="onBulkEdit()">
            <div class="bulk-edit-btn" data-testid="bulk-edit-btn">
                <span>Bulk Edit</span>
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
            </div>
        </ntv-button>
    </div>

    <!-- Hours Rows -->
    <div class="hours__rows" data-testid="hours-rows">
        @for (row of businessHours(); track row.day; let i = $index) {
            <div
                class="hours__row"
                [class.hours__row--disabled]="!row.enabled"
                data-testid="hours-row">
                <!-- Day Badge -->
                <div class="day-badge" data-testid="day-badge">{{ row.day }}</div>

                <!-- Open Time -->
                <ntv-timepicker
                    format="12h"
                    [config]="{ border: true, size: 'sm' }"
                    [formControl]="row.openControl">
                </ntv-timepicker>

                <span class="separator">-</span>

                <!-- Close Time -->
                <ntv-timepicker
                    format="12h"
                    [config]="{ border: true, size: 'sm' }"
                    [formControl]="row.closeControl">
                </ntv-timepicker>

                <!-- 24h Toggle -->
                <ntv-button
                    variant="outline"
                    color="custom"
                    [customColor]="row.is24h ? '#7AC53F' : '#9ca3af'"
                    size="lg"
                    rounded="md"
                    (buttonClick)="toggle24h(i)">
                    24h
                </ntv-button>

                <!-- Add (+) Button -->
                <ntv-button
                    variant="outline"
                    color="custom"
                    customColor="#7AC53F"
                    size="lg"
                    rounded="md"
                    (buttonClick)="toggleEnabled(i)">
                    +
                </ntv-button>
            </div>
        }
    </div>
</div>
